






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Seatings, { RoomState } from '@/services/Seatings'
import videos, { Video } from '@/services/Videos'
import VideoSelect from '@/components/staff/VideoSelect.vue'
import Guests, { GuestList } from '@/services/Guests'
@Component({
  components: { VideoSelect },
})
export default class ArtistVideoAdmin extends Vue {
  @Prop({ required: true }) public seatingId!: string
  @Prop({ required: true }) public roomId!: string
  @Prop({ required: false }) public videoIsPlaying!: boolean
  @Prop({ required: true, default: null }) public guests!: GuestList

  public restaurantId: string = ''
  public videoId: string | null = null
  public roomState: RoomState | null = null
  public videosList: Video[] = []

  public created() {
    this.restaurantId = this.$route.params.restaurantId

    videos.observeVideos(this.restaurantId, videosList => {
      this.videosList = videosList
    })
  }

  public playFullscreenVideo() {
    this.changeFullScreenVideo(this.roomState?.videoId || null)
  }

  public changeFullScreenVideo(videoId: string | null) {
    // for everyone in this room, set the 1-on-1 video
    Object.keys(this.guests).forEach(guestId => {
      if (this.guests[guestId].isWaiter) {
        return
      }
      Guests.setWatchingVideoId(this.restaurantId, this.seatingId, guestId, videoId)
    })
  }

  public playArtistVideo() {
    this.setVideo(this.roomState?.videoId || null, true)
  }

  public stopVideo() {
    if (this.roomState && this.roomState.videoIsPlaying) {
      this.setVideo(this.roomState?.videoId || null)
    } else {
      this.changeFullScreenVideo(null)
    }
  }

  public get nrOfGuests() {
    return Object.keys(this.guests).length
  }

  @Watch('roomId', { immediate: true })
  handleRoomIdChange() {
    Seatings.observeSeatingRoomState(
      this.$route.params.restaurantId,
      this.seatingId,
      this.roomId,
      async roomState => {
        this.roomState = roomState
        this.videoId =
          !this.roomState || this.roomState.videoId === '' ? null : this.roomState.videoId || null
        this.$emit('input', this.roomState)
      }
    )
  }

  private setVideo(videoId: string | null, videoIsPlaying: boolean = false) {
    Seatings.updateRoomState(this.restaurantId, this.seatingId, this.roomId, {
      videoId,
      videoIsPlaying,
    })
  }
}
